export default "__VITE_ASSET__CbUuYUyf__"